import { Injectable } from '@angular/core';
import { AnalyticsEventProvider } from './analytics-event-provider.service';
import { SearchEvent } from '../events/search-event';

export interface SearchEventArgs {
  element?: HTMLInputElement;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsSearchEventProvider extends AnalyticsEventProvider<SearchEvent> {
  createAndPush(args: SearchEventArgs): void {
    const searchText = this.getSearchText(args.element);

    this.push(
      new SearchEvent({
        search_text: searchText,
      }),
    );
  }

  private getSearchText(element: HTMLInputElement | undefined): string {
    if (!element) return '';

    return element.value.trim() || '';
  }
}
